import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Delete = createSvgIcon(
  <>
    <g clipPath="url(#clip0_1783_388216)">
      <path
        opacity="0.15"
        d="M26.5 0.414062V52.5859C33.4184 52.5859 40.0535 49.8376 44.9455 44.9455C49.8376 40.0534 52.5859 33.4184 52.5859 26.5C52.5859 19.5816 49.8376 12.9465 44.9455 8.05445C40.0535 3.16239 33.4184 0.414063 26.5 0.414062V0.414062Z"
        fill="#262D3D"
      />
      <path
        d="M26.5 53C21.2588 53 16.1353 51.4458 11.7774 48.5339C7.41949 45.6221 4.02292 41.4833 2.0172 36.6411C0.0114821 31.7988 -0.513306 26.4706 0.509201 21.3301C1.53171 16.1896 4.05558 11.4678 7.76167 7.76167C11.4678 4.05559 16.1896 1.53171 21.3301 0.509201C26.4706 -0.513306 31.7988 0.0114819 36.6411 2.0172C41.4833 4.02292 45.622 7.41949 48.5339 11.7774C51.4457 16.1353 52.9999 21.2588 52.9999 26.5C52.992 33.5258 50.1976 40.2616 45.2296 45.2296C40.2616 50.1976 33.5258 52.9921 26.5 53ZM26.5 0.828136C21.4226 0.828136 16.4592 2.33376 12.2375 5.15462C8.01575 7.97548 4.72533 11.9849 2.78229 16.6758C0.839247 21.3667 0.330859 26.5285 1.32141 31.5083C2.31197 36.4882 4.75697 41.0624 8.34724 44.6527C11.9375 48.243 16.5118 50.688 21.4916 51.6786C26.4715 52.6691 31.6332 52.1607 36.3242 50.2177C41.0151 48.2746 45.0245 44.9842 47.8453 40.7625C50.6662 36.5408 52.1718 31.5774 52.1718 26.5C52.1641 19.6938 49.4569 13.1685 44.6441 8.35581C39.8314 3.54308 33.3062 0.835886 26.5 0.828136V0.828136Z"
        fill="#455065"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.375 11H29.875V14.75H39.25V15.75H13V14.75H22.375V11ZM23.625 14.75H28.625V12H23.625V14.75ZM15.125 18.5H16.125V40H36.125V18.5H37.125V40V41H36.125H16.125H15.125V40V18.5ZM23.125 33.5V24.125H24.125V33.5H23.125ZM29.75 24.125H28.75V33.5H29.75V24.125Z"
      fill="#455065"
    />
    <defs>
      <clipPath id="clip0_1783_388216">
        <rect width="53" height="53" fill="white" />
      </clipPath>
    </defs>
  </>,
  'Delete'
)

export default Delete
